import React, { useEffect, useState } from "react"

import { api_base_url, browserstring, logout } from "../utils/auth"
import { navigate } from "gatsby"

const axios = require("axios").default

const withJWT = ComponentToWrap => props => {
  const [jwtToken, setJwtToken] = useState(null)

  useEffect(() => {
    const options = {
      method: "post",
      url: `${api_base_url()}/token`,
      data: {
        challenge: browserstring(),
        version: "arbitrary aardvark"
      },
    }

    axios(options)
      .then(response => {
        setJwtToken(response.data)
      })
      .catch(error => {
        // If we fail to obtain JWT token, redirect to the main page.

        logout();
        navigate(`/nointernet`);
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (jwtToken == null) {
    return (<div>Loggar in...
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div></div>)
  } else {
    axios.defaults.headers.common = {'Authorization': `Bearer ${jwtToken}`}
    return (
      <ComponentToWrap
        {...props}
        jwt_token={jwtToken}
      />
    )
  }
}

export default withJWT